import { Chart } from "primereact/chart";
import Spinner from "../../components/spinner";
import moment from "moment";

const TeamPerformanceChart = ({ dashboardData, loading }) => {
  const kioskData = dashboardData?.kioskTicketStats?.[0] || {};
  const teamPerformances = kioskData?.teamPerformances || [];

  const labels = teamPerformances.map((entry) =>
    moment(entry.date).format("DD-MMM")
  );
  const ticketsSolved = teamPerformances.map((entry) => entry.ticketsSolved);
  const ticketsInProgress = teamPerformances.map(
    (entry) => entry.ticketsInProgress
  );

  const lineData = {
    labels: labels,
    datasets: [
      {
        label: "Tickets Solved",
        data: ticketsSolved,
        borderColor: "#36A2EB",
        fill: false,
      },
      {
        label: "Tickets In Progress",
        data: ticketsInProgress,
        borderColor: "#FF6384",
        fill: false,
      },
    ],
  };

  const lineOptions = {
    responsive: true,
    plugins: {
      legend: {
        display: true,
      },
    },
    scales: {
      y: {
        beginAtZero: true,
        ticks: {
          stepSize: 20, 
        },
      },
    },
  };
  

  return (
    <div className="card m-0 line-performance-chart">
      <h3 className="text-lg font-semibold mb-2 border-t pt-2">
        Team Performance (Monthly)
      </h3>
        <Chart
          type="line"
          data={lineData}
          options={lineOptions}
          className="w-full"
        />
    </div>
  );
};

export default TeamPerformanceChart;
